import { render } from "./CouponsComponent.vue?vue&type=template&id=4e6d46ae"
import script from "./CouponsComponent.vue?vue&type=script&lang=js"
export * from "./CouponsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__